(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-drawer__upsell-add');
    if (btn) { cdAdd(btn); return; }
    var arrow = e.target.closest('.cart-drawer__upsell-arrow');
    if (arrow) {
      cdNav(
        arrow.closest('.cart-drawer__upsell-carousel'),
        arrow.classList.contains('cart-drawer__upsell-arrow--next') ? 1 : -1
      );
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('cart-drawer__upsell-select') && e.target.tagName === 'SELECT') {
      var slide = e.target.closest('.cart-drawer__upsell-slide');
      if (!slide) return;
      var btn = slide.querySelector('.cart-drawer__upsell-add');
      if (btn) btn.dataset.variantId = e.target.value;
    }
  });

  function cdNav(carousel, dir) {
    if (!carousel) return;
    var track = carousel.querySelector('.cart-drawer__upsell-track');
    var total = carousel.querySelectorAll('.cart-drawer__upsell-slide').length;
    var idx = Math.max(0, Math.min(total - 1, (parseInt(carousel.dataset.cdIdx || '0', 10)) + dir));
    carousel.dataset.cdIdx = idx;
    track.style.transform = 'translateX(-' + (idx * 100) + '%)';
    carousel.querySelector('.cart-drawer__upsell-arrow--prev').disabled = idx === 0;
    carousel.querySelector('.cart-drawer__upsell-arrow--next').disabled = idx >= total - 1;
  }

  function cdAdd(btn) {
    var vid = parseInt(btn.dataset.variantId, 10);
    if (!vid) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    // Mirror ProductForm.onSubmitHandler exactly:
    // FormData + sections appended the same way Dawn does it.
    var drawer = document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', vid);
    formData.append('quantity', '1');
    formData.append('sections_url', window.location.pathname);
    if (drawer && drawer.getSectionsToRender) {
      formData.append(
        'sections',
        drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      );
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          // Shopify returned an error (out of stock, invalid variant, etc.)
          btn.disabled = false;
          btn.textContent = orig;
          return;
        }

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        }

        var lr = document.querySelector('#CartDrawer-LiveRegionText');
        if (lr) {
          setTimeout(function () {
            lr.textContent =
              (window.cartStrings && window.cartStrings.itemAdded) || 'Item added to cart.';
          }, 400);
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = orig;
      });
  }
})();
